export default __webpack_public_path__ + "src/assets/discord.3c040dd25faa4411a4c10e4fb50d6c7f.svg";